module.exports = __webpack_public_path__ + "static/img/kdkp.dc1e5d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdkp.jpg
// module id = 06wl
// module chunks = 3